
import React from 'react';
import { UCAModule, CommonModule, getEOTFlag } from "uca-react-containers-library";
import Loader from './loader';

const CommunicationPrefV3Component = () => {
    const {isLoading } = CommonModule.useAuth();
    const { saveRouteData } = CommonModule.useRoute();
    const { appData } = CommonModule.useApp();
    const [isInStoreEnable, setIsInStoreEnable] = React.useState(null);
    React.useEffect(() => {
        saveRouteData({ 'currentPage': 'Communication Preferences' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        setTimeout(() => {
            if (window?.analyticsSwy?.testFlags) {
                if (Object.keys(window?.analyticsSwy?.testFlags)?.length > 0) {
                    setIsInStoreEnable(getEOTFlag('ACIP257055') === "a");
                }
            }
        }, 1500);
        // eslint-disable-next-line
    }, [window?.analyticsSwy && Object.keys(window?.analyticsSwy?.testFlags)?.length]);

    if (!appData.isBusinessBanner) {
        if (isLoading || (isInStoreEnable === null)) return <Loader></Loader>;
    } else if (isLoading) {
        return <Loader></Loader>;
    }

    return (
        <CommonModule.ViewportProvider>
            <div class="col-lg-3 col-xl-3">
                <UCAModule.LeftNavigation></UCAModule.LeftNavigation>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
            {isInStoreEnable ?(<UCAModule.CommunicationPreferencesV4></UCAModule.CommunicationPreferencesV4>) : (<UCAModule.CommunicationPreferencesV3></UCAModule.CommunicationPreferencesV3>)}
            </div>
        </CommonModule.ViewportProvider>
    );
};

export default CommunicationPrefV3Component;